export interface IPointConfig {
  radius: number;
  color: string;
  textColor?: string;
  borderColor?: string;
  borderWidth?: number;
  count?: string;
  hasContourShadow: boolean;
}

const DOT_CONFIG = {
  radius: 4,
  color: '#075ad9',
  textColor: 'rgba(255,0,0,1)',
  borderColor: '#ffffff',
  borderWidth: 1,
  count: '0',
  hasContourShadow: true,
};

export function getPointConfig(): IPointConfig {
  return DOT_CONFIG;
}
